<template>
  <div class="course-table">
    <!--头部1-->
    <div class="container">
      <div class="title">
        当前位置：<span class="home" @click="toHome">首页</span> > 直播课表
      </div>
      <div class="navs">
        <div style="display: flex">
          <div
            class="item"
            @click="changeNav(1)"
            :class="activeIndex == 1 ? 'active' : ''"
          >
            直播
          </div>
          <div
            class="item"
            @click="changeNav(2)"
            :class="activeIndex == 2 ? 'active' : ''"
          >
            回放
          </div>
        </div>
        <div v-show="activeIndex == 2">
          <el-input
            style="width: 160px; margin-right: 20px"
            clearable
            v-model="form.course"
            @input="getBackList"
            placeholder="请输入课程名称"
          ></el-input>
          <el-input
            style="width: 160px; margin-right: 20px"
            clearable
            v-model="form.year"
            @input="getBackList"
            placeholder="请输入年份"
          ></el-input>
          <el-select
            style="width: 140px"
            filterable
            clearable
            v-model="form.month"
            @change="getBackList"
            placeholder="请选择月份"
          >
            <el-option
              v-for="(item, index) in monthList"
              :key="index"
              :label="item + '月'"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="content" v-show="activeIndex == 1">
        <div class="item" v-for="(item, i) in broastList" :key="i">
          <div class="title">
            <div class="label">直播</div>
            <div class="time">{{ item.classDate }} {{ item.classTime }}</div>
          </div>
          <div class="name">{{ item.level }}{{ item.course }}</div>
          <div class="sub-tit">{{ item.chapter }}</div>
          <div class="btns">
            <div class="down-load" v-if="item.docHref" @click="downLoad(item)">
              <img
                class="icon"
                src="../../assets/img/icon/icon_down.png"
                alt=""
              />
              <span class="text">下载课件</span>
            </div>
            <div v-else></div>
            <div style="display: flex">
              <el-popover
                placement="top-start"
                title="课前介绍"
                width="200"
                trigger="hover"
                :content="item.chapterIntroduction"
              >
                <div slot="reference" class="btn-introduce"></div>
                <!-- <el-button slot="reference">hover 激活</el-button> -->
              </el-popover>
              <div class="btn" @click="toUrl(item, '直播')">
                <div class="block">
                  <img
                    class="img"
                    src="../../assets/img/icon/icon_play.png"
                    alt=""
                  />
                </div>
                观看
              </div>
              <div class="btn join" @click="toUrl(item, '会议')">
                <div class="block">
                  <img
                    class="img"
                    src="../../assets/img/icon/icon_join.png"
                    alt=""
                  />
                </div>
                加入
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-show="activeIndex == 2">
        <div class="item" v-for="(item, i) in backList" :key="i">
          <div class="title">
            <div class="label back">回放</div>
            <div class="time">{{ item.classDate }} {{ item.classTime }}</div>
          </div>
          <div class="name">{{ item.level }}{{ item.course }}</div>
          <div class="sub-tit">{{ item.chapter }}</div>

          <div class="btns">
            <div class="down-load" @click="downLoad(item)" v-if="item.docHref">
              <img
                class="icon"
                src="../../assets/img/icon/icon_down.png"
                alt=""
              />
              <span class="text">下载课件</span>
            </div>
            <div v-else></div>
            <div style="display: flex; float: right">
              <el-popover
                placement="top-start"
                title="课前介绍"
                width="200"
                trigger="hover"
                :content="item.chapterIntroduction"
              >
                <div slot="reference" class="btn-introduce"></div>
                <!-- <el-button slot="reference">hover 激活</el-button> -->
              </el-popover>
              <div
                v-if="!item.playbackProgress"
                class="btn join back"
                @click="showVideo(item)"
              >
                <div class="block">
                  <img
                    class="img"
                    src="../../assets/img/icon/icon_join.png"
                    alt=""
                  />
                </div>
                回放
              </div>
              <div class="video-pro" @click="showVideo(item)" v-else>
                已观看
                {{ parseInt((item.playbackProgress / item.duration) * 100) }}
                %
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        title="详情"
        @closed="onClose"
        :visible.sync="dialogVisible"
        width="1160px"
      >
        <kf-video
          :fluid="true"
          :controls="true"
          :preload="true"
          @pause="pause"
          @play="play"
          @timeupdate="timeupdate"
          :goTime="itemInfo.playbackProgress ? itemInfo.playbackProgress : 0"
          :src="videoSrc"
        ></kf-video>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
import FileUtil from "../../common/FileUtil";
import kfVideo from "../../components/kf-video.vue";
export default {
  mixins: [page_mx],
  components: { kfVideo },

  data() {
    return {
      broastList: [],
      dialogVisible: false,
      dialogTitle: "",
      backList: [],
      videoSrc: "",
      form: {
        year: new Date().getFullYear(),
      },
      itemInfo: {},
      lookTime: 0,
      saveVideoTimer: "",
      activeIndex: "1",
      monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    toHome() {
      this.$router.push({
        path: "./home",
      });
    },
    showVideo(item) {
      if (!item.playbackHref) return this.$message("暂无回放视频~");
      this.dialogVisible = true;
      this.videoSrc = item.playbackHref;
      this.itemInfo = JSON.parse(JSON.stringify(item));
    },
    onClose() {
      this.videoSrc = "";
    },
    timeupdate(time) {
      this.lookTime = parseInt(time);
    },
    play() {
      console.log(11);
      clearInterval(this.saveVideoTimer);
      this.saveVideoTimer = setInterval(() => {
        console.log("一分钟记录一下");
        this.changeStudy();
      }, 1 * 60 * 1000);
    },
    pause() {
      clearInterval(this.saveVideoTimer);
    },
    changeStudy() {
      this.$api.sms.study.studentLiveCourseSchedule_updatePlaybackProgress
        .put({
          duration: this.itemInfo.duration,
          progress: this.lookTime,
          liveCourseScheduleId: this.itemInfo.id,
        })
        .then(() => {
          this.getBackList();
        });
    },
    getData() {
      this.$api.cms.content.liveCourseSchedule_listCkbdLiveForClient
        .get()
        .then((res) => {
          this.broastList = res.data;
        });
      this.getBackList();
    },
    getBackList() {
      this.$api.cms.content.liveCourseSchedule_listCkbdPlaybackForClient
        .get(this.form)
        .then((res) => {
          this.backList = res.data;
        });
    },
    toUrl(item, flag) {
      let now = Date.now();
      if (now < item.liveStart || now > item.liveEnd)
        return this.$message.warning(
          `当前时间不可${flag === "会议" ? "加入" : "观看"}直播`
        );
      this.$api.sms.study.studentLiveCourseSchedule_watchLive
        .put({
          liveCourseScheduleId: item.id,
        })
        .then(() => {
          window.open(flag === "会议" ? item.meetingHref : item.liveHref);
        });
    },
    downLoad(item) {
      FileUtil.download(item.docHref);
    },
    changeNav(i) {
      this.activeIndex = i;
    },
  },
};
</script>
<style lang="less" scoped>
.course-table {
  min-height: 600px;
  .container {
    width: 1160px;
    margin: 30px auto 0;
    .title {
      font-size: 16px;
      color: #666;
      .home {
        cursor: pointer;
      }
    }
    .navs {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      .item {
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 77px;
        height: 28px;
        background-color: #f2f2f2;
        border-radius: 29px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
      }
      .item.active {
        color: #fff;
        background-color: #00b861;
      }
    }
    .content {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      .item {
        margin-right: 16px;
        margin-top: 16px;
        padding: 16px;
        width: 376px;
        height: 166px;
        background: #fff;
        box-shadow: 0px 8px 32px 0px rgba(66, 97, 159, 0.1);
        border-radius: 8px;
        box-sizing: border-box;
        .title {
          display: flex;
          .label {
            margin-right: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 20px;
            background: rgba(65, 204, 138, 0.1);
            border-radius: 4px;
            font-size: 12px;
            color: #00b861;
          }
          .label.back {
            color: #ff9e11;
            background: rgba(255, 158, 17, 0.1);
          }
          .time {
            font-size: 12px;
            color: #666;
          }
        }

        .name {
          margin-top: 10px;
          font-size: 18px;
          color: #333;
          font-weight: bold;
          line-height: 25px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .sub-tit {
          padding-top: 8px;
          font-size: 14px;
          line-height: 18px;
          color: #666;
        }
        .btns {
          margin-top: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .down-load {
            cursor: pointer;
            display: flex;
            align-items: center;
          }
          .icon {
            width: 16px;
            height: 16px;
          }
          .text {
            margin-left: 6px;
            color: #348cff;
            cursor: pointer;
          }
          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 68px;
            height: 28px;
            background: rgba(0, 184, 97, 0);
            border-radius: 32px;
            border: 1px solid #00b861;
            color: #00b861;
            cursor: pointer;
            .block {
              width: 16px;
              height: 16px;
              margin-right: 4px;
              .img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .btn.join {
            margin-left: 10px;
            width: 68px;
            height: 28px;
            background: #00b861;
            border-radius: 32px;
            border: 1px solid #00b861;
            color: #fff;
          }
          .btn.join.back {
            background: #ff9e11;
            border: 1px solid #ff9e11;
          }
          .btn-introduce {
            margin-right: 10px;
            width: 94px;
            height: 28px;
            cursor: pointer;
            background-image: url("../../assets/img/btn.png");
            background-repeat: no-repeat;
          }
          .video-pro {
            cursor: pointer;
            color: #ff9e11;
          }
        }
      }
      .item:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>
